var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "img_preview_wrap" }, [
    _c("div", { staticClass: "img_preview_box" }, [
      _c("div", { staticClass: "img_head" }, [
        _c("p", { staticClass: "img_name" }, [_vm._v(_vm._s(_vm.imgName))]),
        _vm._v(" "),
        _c("span", {
          staticClass: "el-icon-circle-close close_btn",
          on: {
            click: function($event) {
              return _vm.closeFn()
            }
          }
        })
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "img-box" },
        [
          _c("transition", { attrs: { name: "fade" } }, [
            _c("div", { staticClass: "img-view" }, [
              _c("div", { staticClass: "img-layer" }),
              _vm._v(" "),
              _c("div", { staticClass: "img" }, [
                _c("img", { staticClass: "bigImg", attrs: { src: _vm.imgSrc } })
              ])
            ])
          ])
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-295aeb3f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-295aeb3f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/szrt_revision/new_course_module/editCourse/sourceMaterial/imgView.vue
// module id = null
// module chunks = 